import React, { useContext } from 'react';
import { StartFarmContext } from '../../../context/startFarmContext';

const FarmItems = ({ title, subtitle, children, small, subText, name, salute }) => {
  const context = useContext(StartFarmContext);

  const { handleDetailsModal } = context;

  return (
    <div className="relative">
      <h5 className="text-center text-cf-300">
        {salute} {name} {title}
      </h5>

      <div className="border-b border-gray-300 pt-12"></div>

      <div className="text-center">
        <div className="my-12">
          <h6>{subtitle} </h6>
          {small && (
            <small>
              Click here to view{' '}
              <span onClick={handleDetailsModal} className="text-cf-300 cursor-pointer">
                Farm details
              </span>
            </small>
          )}
        </div>

        <div className="flex flex-wrap">{children}</div>
      </div>

      <div className="border-b border-gray-300 pt-12"></div>

      <div className="mt-10 text-center">
        {subText && <p>Select your preferred package to start farming!</p>}
      </div>
    </div>
  );
};

export default FarmItems;
